var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"app-hero-image-single"},[_c('img',{staticClass:"image",attrs:{"alt":_vm.media.alt,"src":_vm.media.url,"fetchpriority":"high"}})])}
var staticRenderFns = []

export { render, staticRenderFns }